module.exports = __webpack_public_path__ + "img/logo-transparent.398453c3.png";